import { createSelector } from 'reselect';
import Utils from 'yoda-core-components/lib/helpers/Utils/Utils';
import { selectFeatureFlags, selectPreferences, selectReqHeaders } from './ContextSelector';
import { keepMeLoggedIn } from '../common/Constants';

export const DEFAULTS = {};

const isKeepMeLoggedInEnabled = (featureFlags, preferences, reqHeaders) =>
    Utils.isFeatureEnabled(
        featureFlags,
        preferences,
        reqHeaders,
        // featureflag,        cookieName            headerName
        'enableKeepMeLoggedIn',
        keepMeLoggedIn.cookieFlagName,
        keepMeLoggedIn.headerFlagName
    );

// FF
export const selectKeepMeLoggedInThrottleFF = createSelector(
    [selectFeatureFlags, selectPreferences, selectReqHeaders],
    isKeepMeLoggedInEnabled
);
